import React, { useState } from "react";
import {
  Box,
  Button as MuiButton,
  FormControl,
  InputBase,
  styled,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { format, getUnixTime } from "date-fns";
import { Typography } from "components/Typography";
import { ActivityIcon, SearchIcon, ExportIcon } from "components/Icons";
import { useGetActivitiesQuery, useGetActivityQuery } from "api/activity";
import { exportCSV } from "utils/exportCsv";
import { DateRangePicker } from "components/DateRangePicker";
import { ActivitiesDataTable } from "./component/ActivityDataTable";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  paddingLeft: "7px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  border: "1.5px solid #EFF1F4",
  borderRadius: "8px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
  },
}));

const Select = styled(MuiSelect)(() => ({
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #EFF1F4 !important",
  },
}));

const Button = styled(MuiButton)(() => ({
  borderColor: "#EFF1F4",
  color: "black",
  height: "40px",
  textTransform: "capitalize",
}));

const PAGE_SIZE = 1000;
const SORT_ORDER = "date-desc";

export const Activity = () => {
  const [activity, setActivity] = useState("");

  const [search, setSearch] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const { data = [], isLoading } = useGetActivityQuery({
    search,
    from,
    to,
    limit: PAGE_SIZE,
    sort: SORT_ORDER,
    activity,
  });

  const { data: activitiesData} = useGetActivitiesQuery()

  const acData = activitiesData ?? []
  const ActivityTypeOptions = acData.map((item) => ({
    label: item.name,
    value: item.activityId,
    id: item.activityId
  }))

 const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleActivityChange = (event) => {
    setActivity(event.target.value);
  };

  const handleSelectRange = (range) => {
    setFrom(getUnixTime(range.startDate));
    setTo(getUnixTime(range.endDate));
  };

  const handleExportCSV = () => {
    if (!data || data.length === 0) return;

    const formattedData = data.map(
      ({ createdBy, description, createdOn}) => ({
        "Created By": createdBy,
        Description: description,
        Date: format(new Date(createdOn * 1000), "dd/MM/yyyy hh:mm a"),
      })
    );

    exportCSV(formattedData, "activities.csv");
  };

  return (
    <Box>
      <Wrapper sx={{ justifyContent: "space-between" }}>
        <Wrapper>
          <Typography variant="dashboardHeading">Activity Log</Typography>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search" }}
              value={search}
               onChange={handleSearch}
            />
          </Search>
        </Wrapper>
        <Wrapper>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <Select
            value={activity}
              displayEmpty
              onChange={handleActivityChange}
            >
              <MenuItem value="" disabled>
                <Wrapper>
                  <ActivityIcon />
                  <Typography sx={{ margin: "2px 0px 0px 5px" }} variant="body">
                    Activities
                  </Typography>
                </Wrapper>
              </MenuItem>
              <MenuItem value="">All</MenuItem> 
                {ActivityTypeOptions.map((option) => (
              <MenuItem key={option.id} value={option.value}>
                {option.label}
              </MenuItem>
  ))}
            </Select>
          </FormControl>
          <Wrapper sx={{ columnGap: "8px" }}>
            <DateRangePicker handleSelectRange={handleSelectRange} />
            <Button variant="outlined" onClick={handleExportCSV}>
              <Wrapper>
                <ExportIcon />
                <div style={{ marginTop: 5 }}> Export csv</div>
              </Wrapper>
            </Button>
          </Wrapper>
        </Wrapper>
      </Wrapper>

      <ActivitiesDataTable data={data} isLoading={isLoading} />
    </Box>
  );
};
